import { BasicInformation } from "../constatnts/information";

export const pageTitle = title => {
  return (document.title =
    title + ' | '+ BasicInformation.companyName);
};
